import React, { Component } from "react";

/**
 * Display list items in a removable badge.
 * <RemovableBadge label={} handleRemove={} stateKey={} stateIndex={} toDestroy={} editMode={} />
 * props:
 *  - String   label
 *  - function handleRemove
 *  - String   stateKey
 *  - Integer stateIndex index of the badge item in the item type's
 *            array in parent component's state.
 *  - Boolean toDestroy strikethrough if saving a form will remove the
 *            badge from the list.
 *  - Boolean editMode Can the user remove this badge?
 **/
const RemovableBadge = (props) => {
  let label = props.toDestroy ? <s>{props.label}</s> : props.label;
  let rmBtn =
    !props.toDestroy && props.editMode ? (
      <button
        className="btn btn-link text-danger"
        onClick={() => {
          props.handleRemove(props.stateIndex);
        }}
      >
        ×
      </button>
    ) : (
      ""
    );

  return (
    <div className="ml-1 test-removable-badge">
      {rmBtn}
      <span className="p-3">{label}</span>
    </div>
  );
};

export default RemovableBadge;
